import { KrBadge } from '@/common/card/KrBadge';
import { StringUtils } from '@/common/utils/StringUtils';
import { Box } from '@mui/material';
import { useMemo } from 'react';

export const EnumCellRenderer = ({ value, colDef }) => {
  const enumSpec = useMemo(() => {
    return colDef?.values?.find((spec) => spec.code === value);
  }, [colDef, value]);

  if (!enumSpec) {
    return <Box>{value}</Box>;
  }

  return (
    <KrBadge
      label={enumSpec.displayName}
      icon={enumSpec?.icon}
      color={StringUtils.colorToHexCode(enumSpec?.color)}
    ></KrBadge>
  );
};
